import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BsArrowRight, BsApple, BsAndroid2, BsSearch } from 'react-icons/bs'
import { FaApple, FaGooglePlay } from 'react-icons/fa'
import ellipse from '../../../assets/Ellipse.svg'
import box from '../../../assets/box.svg'
import send from '../../../assets/send.svg'
import cart from '../../../assets/cart.svg'
import location from '../../../assets/locationBlue.svg'
import dottedBox from '../../../assets/dottedBox.svg'
import { Button } from '../../../UI'
import scooter from '../../../assets/scotter.svg'
import Container from './styles'

const Jumbotron = () => {
  const navigate = useNavigate()
  const [trackingNumber, setTrackingNumber] = useState('')

  const handleTrackOrder = () => {
    if (trackingNumber.trim()) {
      navigate(`/track-order/${trackingNumber}`)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleTrackOrder()
    }
  }

  return (
    <Container>
      <img src={box} className="floating--img img--left__top" alt="scooter" />
      <img
        src={cart}
        className="floating--img img--left__bottom"
        alt="scooter"
      />
      <img src={send} className="floating--img img--right__top" alt="scooter" />
      <img
        src={location}
        className="floating--img img--right__bottom"
        alt="scooter"
      />
      <h1>We Make Shipping Big Stuff Easy</h1>
      <div className="ellipse--container">
        <img src={ellipse} alt="Ellipse" />
        <h2>
          Meet the expert shippers to transport goods Anytime! Anywhere!. Doing
          it
          <br /> right cost less in the end
        </h2>
      </div>
      <div className="img--container">
        <img src={scooter} alt="scooter" />
      </div>
      
      <div className="action-buttons">
       <div className="rider-apps">
          <p className="rider-text">Rider App</p>
          <div className="app-buttons">
            <button 
              className="app-btn ios-btn"
              onClick={() => alert('iOS app coming soon!')}
              style={{ opacity: 0.6, cursor: 'not-allowed' }}
            >
              <FaApple />
              <div className="btn-text">
                <span className="small">Coming Soon</span>
                <span className="large">App Store</span>
              </div>
            </button>
            <a 
              href="/app-release.apk"
              download="pickup-logistics.apk"
              className="app-btn android-btn"
            >
              <FaGooglePlay />
              <div className="btn-text">
                <span className="small">Download for</span>
                <span className="large">Android</span>
              </div>
            </a>
          </div>
        </div>

        <div className="track-order">
          <p className="track-text">Track Your Order</p>
          <div className="track-search">
            <input
              type="text"
              placeholder="Enter tracking number (e.g., PKP...)"
              value={trackingNumber}
              onChange={(e) => setTrackingNumber(e.target.value)}
              onKeyPress={handleKeyPress}
              className="track-input"
            />
            <button onClick={handleTrackOrder} className="track-btn">
              <BsSearch />
              Track
            </button>
          </div>
        </div>
      </div>

      <img src={dottedBox} className="dottedBox--img" alt="dotted" />
    </Container>
  )
}

export default Jumbotron
